import { render, staticRenderFns } from "./manage-keywords.vue?vue&type=template&id=57f0a77a&"
import script from "./manage-keywords.ts?vue&type=script&lang=ts&"
export * from "./manage-keywords.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports